import { render, staticRenderFns } from "./DynamicRuleOfferSaleBase.vue?vue&type=template&id=55684b22&scoped=true"
import script from "./DynamicRuleOfferSaleBase.vue?vue&type=script&lang=js"
export * from "./DynamicRuleOfferSaleBase.vue?vue&type=script&lang=js"
import style0 from "./DynamicRuleOfferSaleBase.vue?vue&type=style&index=0&id=55684b22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55684b22",
  null
  
)

export default component.exports